import { action, observable } from 'mobx'
import { $post } from '@/api'

interface MallOrderCount {
    accepted_count: number
    apply_refund_count: number
    finished_count: number
    handling_count: number
    supplement_count: number
    team_purchase_user_count: number
}

class MallOrderStore {
    @observable
    orderCount: MallOrderCount | null = null

    @observable
    orderListRefresh = false

    @observable
    newOrderNo = ''

    @action
    setOrderListRefresh() {
        this.orderListRefresh = !this.orderListRefresh
    }

    @action
    setShowNewOrder(orderNo: string) {
        this.newOrderNo = orderNo
    }

    @action
    getOrderCount() {
        $post({
            url: '/mall/getonlineorderscount',
        }).then(data => {
            this.orderCount = data
        })
    }
}

export const mallOrderStore = new MallOrderStore()
